<template>
  <div class="border">
    <h4>Платиковые карты</h4>
    <list
      :columns="columns"
      :modalCreate="modalCreate"
      :removeLink="removeLink"
      :cardLink="cardLink"
      :isUpdate="true"
      :isAdd="true"
      :itemLink="itemLink"
      title_add="Добавить подкатегорию"
      :setLink="setLink"
      :openItem="false"
      :fields="fields"
      :params="params"
      :searchDisable="true"
      @change="change"
      @changeFunction="changeFunction"
      v-model="val"
    />
  </div>
</template>
<script>
export default {
  name: "products",
  methods: {
    changeFunction(val) {},
    change(val) {},
  },
  props: ["id"],
  created() {
    this.itemLink += `/${this.id}/subcategories`;
    this.setLink += `/${this.id}/subcategories`;
  },
  data() {
    return {
      params: {},
      val: [],
      modalCreate: "field",
      fields: [
        {
          col: "col-12",
          label: "Название",
          labelKey: "Название",
          key: "name",
          type: "field",
        },
      ],
      /** APIs */
      removeLink: "",
      cardLink: "item_category",
      itemLink: "categories",
      setLink: "categories",
      columns: [
        {
          key: "name",
          titleKey: "name",
          title: "Название",
          checkbox: false,
          control: false,
          align: "left",
          timer: false,
          detail: false,
        },
        {
          key: "is_active",
          titleKey: "is_active",
          title: "Активен",
        },
        {
          detail: true,
        },
      ],
    };
  },
};
</script>